import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
const root = ReactDOM.createRoot(document.getElementById("root"));

//Axios Default
axios.defaults.baseURL = process.env.REACT_APP_API;

//TODO: Uncomment when Authentication Is Enabled
(function () {
  const storedData = JSON.parse(localStorage.getItem("userData"));

  if (storedData) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${storedData.token}`;
  } else {
    axios.defaults.headers.common["Authorization"] = null;
    /*if setting null does not remove `Authorization` header then try
                  delete axios.defaults.headers.common['Authorization'];
                */
  }
})();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
